/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Search_LabelInputs */



/**
* | output |
* | --- |
* | "Search" |
*
* @param {Find_Replace_Search_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_search_label = /** @type {((inputs?: Find_Replace_Search_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Search_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher")
	if (locale === "de") return /** @type {LocalizedString} */ ("Suchen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricerca")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поиск")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("搜索")
	if (locale === "ja") return /** @type {LocalizedString} */ ("検索")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खोज")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Procurar")
	return /** @type {LocalizedString} */ ("Search")
});